var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gat-tab',{attrs:{"items":_vm.tabs,"show-in-toolbar":true}}),_c('keep-alive',[_c('router-view',{attrs:{"value":_vm.vessel,"location":"vessel","parentId":_vm.vesselId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }